import React from "react";
import IntroBg from "../assets/hero-illustration.svg";
import {Link} from "react-router-dom";
import "./Intro.css";

function Intro() {
    return (
        <div>
            <section className="intro-home">
                <div className='intro-home-logo'>
                    <div className="intro-home-container">
                        <div className="intro-home-content">
                            <div>
                                <h1 id="intro-heading">
                                    Discover deeper insights at scale with AI
                                </h1>
                                <p>
                                    Gain deeper insights into your customer feedback with AI-powered collection,
                                    analysis and actions.
                                </p>
                            </div>
                            <a href="/schedule-demo" style={{textDecoration: "none"}}>
                                <div className="intro-home-content-btn">
                                    <span>Schedule a demo</span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L8.78033 20.0303C8.48744 20.3232 8.01256 20.3232 7.71967 20.0303C7.42678 19.7374 7.42678 19.2626 7.71967 18.9697L14.6893 12L7.71967 5.03033C7.42678 4.73744 7.42678 4.26256 7.71967 3.96967C8.01256 3.67678 8.48744 3.67678 8.78033 3.96967L16.2803 11.4697Z"
                                            fill="#0F172A"
                                        />
                                    </svg>
                                </div>
                            </a>
                        </div>
                        <div className="intro-home-image">
                            <img src={IntroBg} alt="intro background"/>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Intro;
